module.exports = __webpack_public_path__ + "media/footer/footerRightWave-694bc45e.png";